import PortsAutoComplete from "components/common/PortsAutoComplete";
import VesselAutoComplete from "components/common/VesselAutoComplete";
import { fromUTC } from "helpers/dates";
import { DatePicker, RaisedButton } from "material-ui";
import moment from "moment";
import React, { useContext, useState } from "react";
import BasicCheckBox from "./Basic/BasicCheckBox";
import BasicSelector from "./Basic/BasicSelector";
import AddUpdateButtons from "./RowData/AddUpdateButtons";
import { VesselDwtTypesContext } from "./TcIndexPage";
import styles from './styles';

export default function Filters({ filters, changeFilters, clearFilters }) {
    const vesselDwtTypes = useContext(VesselDwtTypesContext);
    const [ clear, setClear ] = useState(false);
    const maxDate = new Date();

    const selectVessel = (vessel) => {
        changeFilters({ vesselId: vessel._id });
    }

    const selectVesselType = (vesselDwtGroup) => {
        changeFilters({ vesselDwtGroup });
    }

    const selectPort = (field, val) => {
        changeFilters({ [field]: val._id });
    }

    const handleChangeDate = (field, val) => {
        changeFilters({ [field]: val });
    }

    const handleChangeConfirmed = (val) => {
        changeFilters({ confirmed: val });
    }

    const _clearFilters = () => {
        clearFilters();
        setClear(true);
    }

    return (
        <React.Fragment>
            <div className="item" style={{ marginRight: '10px' }}>
                <div className="row">
                    <div className="col-xs-3">
                        <VesselAutoComplete
                            selectValue={selectVessel}
                            hintText='Vessel'
                            shouldClearCustomValue={clear}
                        />
                    </div>
                    <div className="col-xs-3">
                        <BasicSelector 
                            value={filters.vesselDwtGroup}
                            dataList={vesselDwtTypes.filter(v => v.name)}
                            hintText="Vessel Type"
                            onChange={(e, _i, value) => selectVesselType(value)}
                            style={{ fontSize: '13px', height: '48px' }}
                            labelStyle={{ padding: 0, top: 'unset' }}
                            floatingLabelStyle={{ top: '14px' }}
                            fields={["name"]}
                        />
                    </div>
                    {
                        [
                            { field: 'regionFrom', hintText: 'Region From' },
                            { field: 'regionTo', hintText: 'Region To' },
                        ].map((v, i) => {
                            return (
                                <div className="col-xs-3">
                                    <PortsAutoComplete 
                                        key={`${v.field}_${i}`}
                                        customValue={filters[v.field] ? filters[v.field].name : ''}
                                        shouldClearCustomValue={clear}
                                        handleChangeCustomValue={() => {}}
                                        selectValue={e => selectPort(v.field, e)}
                                        floatingLabelStyle={{ display: 'none' }}
                                        hintText={v.hintText}
                                        inputStyle={{ fontSize: '10px' }}
                                        style={{ top: 'unset' }}
                                        menuStyle={{ width: '300px' }}
                                        popoverProps={{
                                            style: { width: '300px' }
                                        }}
                                        withAreas
                                        mainRegions
                                        onlyAreas
                                        isInBalticIndex
                                    />
                                </div>
                            );    
                        })
                    }
                </div>
            </div>
            <div className="item">
                <div className="row">
                    {
                        [
                            { field: 'lay', hintText: 'Lay' },
                            { field: 'can', hintText: 'Can' }
                        ].map((v, i) => {
                            return (
                                <div className="col-xs-2" key={`${v.field}_${i}`}>
                                    <DatePicker 
                                        autoOk
                                        maxDate={v.field === 'lay' ? (filters.can ? new Date(filters.can) : maxDate) : null}
                                        minDate={v.field === 'can' ? (filters.lay ? new Date(filters.lay) : undefined) : null}
                                        onChange={(_, date) => {
                                            v.field === 'lay' && handleChangeDate(v.field, moment(date).utcOffset(0, true));
                                            v.field === 'can' && handleChangeDate(v.field, moment(date).utc().endOf('day').add(1, 'day'));
                                        }}
                                        value={filters[v.field] ? fromUTC(filters[v.field]) : undefined}
                                        inputStyle={{ fontSize: '13px', cursor: 'pointer', textAlign: 'center' }}
                                        textFieldStyle={{ width: 'unset', }}
                                        hintText={v.hintText}
                                        hintStyle={{ fontSize: '13px' }}
                                    />
                                </div>
                            );
                        })
                    }
                    <div className="col-xs-2">
                        <BasicCheckBox 
                            label="Not confirmed"
                            labelStyle={{ fontSize: '10px', width: '100%' }}
                            iconStyle={{ marginRight: 0 }}
                            style={{ paddingTop: '15px' }}
                            checked={!filters.confirmed}
                            handleChange={(c) => handleChangeConfirmed(!c)}
                        />
                    </div>
                    <div className="col-xs-2">
                        <RaisedButton 
                            label='Clear'
                            labelStyle={{ fontSize: '13px' }}
                            style={{ ...styles.buttons.style }}
                            onClick={_clearFilters}
                        />
                    </div>
                    <AddUpdateButtons 
                        style={{ ...styles.buttons.style }}
                        labelStyle={{ ...styles.buttons.labelStyle }}
                    />
                </div>
            </div>
        </React.Fragment>
    );
}



// WEBPACK FOOTER //
// ./app/components/TcIndex/Filters.jsx